import * as React from 'react';
import '../models/adyen/payment-type.js';
import { PaymentMethod } from '../models/cart-payment-methods/cart-payment-methods.js';
import '../models/googlePay/types.js';
import '../models/payment/types.js';
import '../models/paypal/context.js';
import { useIsApplePayActive } from './use-is-apple-pay-active.js';
import { useIsExpressPaymentMethodSupported } from './use-is-express-payment-method-supported.js';

const useIsApplePaySupportedForCart = (cartId)=>{
    const isApplePayActive = useIsApplePayActive();
    const [getIsApplePaySupportedForCart, { isPaymentMethodSupported , called , loading , error  }] = useIsExpressPaymentMethodSupported(PaymentMethod.APPLE_PAY);
    React.useEffect(()=>{
        if (cartId) {
            getIsApplePaySupportedForCart(cartId);
        }
    }, [
        getIsApplePaySupportedForCart,
        cartId
    ]);
    if (!isApplePayActive) {
        return {
            isApplePaySupportedForCart: false,
            loading: false,
            called: true,
            error: undefined
        };
    }
    return {
        isApplePaySupportedForCart: isPaymentMethodSupported,
        loading,
        called,
        error
    };
};

export { useIsApplePaySupportedForCart };
//# sourceMappingURL=use-is-apple-pay-supported-for-cart.js.map
